import { useState } from 'react';
import { useAuth } from '../AuthContext.jsx';
import { api } from '../api.js';
import { EVENTS } from '@shared/events.js';

export default function Settings() {
  const { user, updateUser } = useAuth();
  const [form, setForm] = useState({
    nickname: user?.nickname || '',
    avatar: user?.avatar || '',
    started_at: user?.started_at || '',
    main_event: user?.main_event || '3x3',
    checkin_freq: user?.checkin_freq || 'daily',
  });
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [pwOld, setPwOld] = useState('');
  const [pwNew, setPwNew] = useState('');
  const [pwConfirm, setPwConfirm] = useState('');
  const [pwMsg, setPwMsg] = useState('');
  const [pwErr, setPwErr] = useState('');
  const [pwBusy, setPwBusy] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setErr('');
    setMsg('');
    setBusy(true);
    try {
      const data = await api('/me', { method: 'PATCH', body: form });
      updateUser(data.user);
      setMsg('资料已保存');
      setTimeout(() => setMsg(''), 2500);
    } catch (error) {
      setErr(error.message);
    } finally {
      setBusy(false);
    }
  };

  const savePassword = async (e) => {
    e.preventDefault();
    setPwErr('');
    setPwMsg('');
    if (pwNew.length < 6) {
      setPwErr('新密码至少 6 位');
      return;
    }
    if (pwNew !== pwConfirm) {
      setPwErr('两次输入的新密码不一致');
      return;
    }
    setPwBusy(true);
    try {
      await api('/auth/password', {
        method: 'PATCH',
        body: { old_password: pwOld, new_password: pwNew },
      });
      setPwOld('');
      setPwNew('');
      setPwConfirm('');
      setPwMsg('密码已更新，下次请用新密码登录');
    } catch (error) {
      setPwErr(error.message);
    } finally {
      setPwBusy(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto space-y-6">
      <div>
        <h1 className="text-xl font-bold text-slate-100">个人设置</h1>
        <p className="text-sm text-slate-500 mt-1">修改昵称、头像、主项目与打卡频率</p>
      </div>
      <form onSubmit={save} className="card p-6 space-y-4">
        {msg && <div className="text-sm bg-good/10 text-good border border-good/20 rounded-xl px-3.5 py-2.5">{msg}</div>}
        {err && <div className="text-sm bg-danger/10 text-danger border border-danger/20 rounded-xl px-3.5 py-2.5">{err}</div>}
        <div>
          <label className="label">昵称</label>
          <input className="input" value={form.nickname} onChange={set('nickname')} required />
        </div>
        <div>
          <label className="label">头像链接（可留空使用默认）</label>
          <input className="input" value={form.avatar} onChange={set('avatar')} placeholder="https://…" />
        </div>
        <div>
          <label className="label">开始学习魔方的日期</label>
          <input className="input" type="date" value={form.started_at} onChange={set('started_at')} />
        </div>
        <div>
          <label className="label">当前主项目</label>
          <select className="input" value={form.main_event} onChange={set('main_event')}>
            {EVENTS.map((e) => (
              <option key={e.key} value={e.key}>{e.name}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="label">打卡频率目标</label>
          <select className="input" value={form.checkin_freq} onChange={set('checkin_freq')}>
            <option value="daily">每日打卡</option>
            <option value="weekly">每周打卡</option>
          </select>
        </div>
        <button className="btn-primary" disabled={busy}>{busy ? '保存中…' : '保存'}</button>
      </form>
      <div className="card p-6 space-y-4">
        <div>
          <h2 className="text-base font-semibold text-slate-100">修改密码</h2>
          <p className="text-sm text-slate-500 mt-1">
            {user?.role === 'coach' ? '定期更换密码更安全' : '忘记密码时可联系教练重置后再修改'}
          </p>
        </div>
        {pwMsg && <div className="text-sm bg-good/10 text-good border border-good/20 rounded-xl px-3.5 py-2.5">{pwMsg}</div>}
        {pwErr && <div className="text-sm bg-danger/10 text-danger border border-danger/20 rounded-xl px-3.5 py-2.5">{pwErr}</div>}
        <form onSubmit={savePassword} className="space-y-4">
          <div>
            <label className="label">原密码</label>
            <input className="input" type="password" value={pwOld} onChange={(e) => setPwOld(e.target.value)} required autoComplete="current-password" />
          </div>
          <div>
            <label className="label">新密码（至少 6 位）</label>
            <input className="input" type="password" value={pwNew} onChange={(e) => setPwNew(e.target.value)} required autoComplete="new-password" />
          </div>
          <div>
            <label className="label">确认新密码</label>
            <input className="input" type="password" value={pwConfirm} onChange={(e) => setPwConfirm(e.target.value)} required autoComplete="new-password" />
          </div>
          <button className="btn-primary" disabled={pwBusy}>{pwBusy ? '提交中…' : '更新密码'}</button>
        </form>
      </div>
      <div className="card p-5 text-sm text-slate-400">
        <p className="font-medium text-slate-200 mb-2">账号信息</p>
        <p>邮箱：{user?.email}</p>
        <p className="mt-1">角色：{user?.role === 'coach' ? '教练' : '学生'}</p>
        <p className="mt-1">注册时间：{user ? new Date(user.created_at).toLocaleDateString('zh-CN') : ''}</p>
        {user?.role !== 'coach' && (
          <>
            <p className="mt-1">
              账号状态：
              {user?.disabled
                ? <span className="text-danger">已停用（请联系教练）</span>
                : user?.expires_at && Date.now() > user.expires_at
                  ? <span className="text-warn">课程已到期（请联系教练续课）</span>
                  : <span className="text-good">正常</span>}
            </p>
            <p className="mt-1">
              有效期：
              {user?.expires_at
                ? `至 ${new Date(user.expires_at).toLocaleDateString('zh-CN')}`
                : '长期有效'}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
